import React, { Component, Suspense } from "react";
import { TheContent, TheSidebar, TheFooter, TheHeader } from "./index";
import { render } from "enzyme";
import IdleTimer from "react-idle-timer";
import {Link, useHistory, useParams} from 'react-router-dom'

function TheLayout() {
  const history = useHistory();

    return (
      <div className="c-app c-default-layout">
        <IdleTimer
          events={[
            'mousedown',
            'DOMMouseScroll',
            'keydown'
          ]}
          timeout={1000 * 60 * 15}
          onActive={(e) => console.log('active', e)}
          onIdle={(e) => {
            history.push("/logout?inactivity=true")
          }}
          onAction={(e) => console.log('action', e)}
          debounce={250}
        />

        <TheSidebar />
        <div className="c-wrapper">
          <TheHeader />
          <div className="c-body">
            <TheContent />
          </div>
          <TheFooter />
        </div>
      </div>
    );
}

export default TheLayout;
